import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  console.log('🛡️ AuthGuard: Iniciando verificación...');
  
  // Esperar a que el AuthService complete su inicialización
  // En modo cookie, esto incluye la verificación con el backend
  await authService.waitForInitialization();
  
  console.log('🛡️ AuthGuard: Inicialización completa');

  // Usar la versión síncrona que verifica el estado en memoria
  const isAuth = authService.isAuthenticatedSync();
  console.log('🛡️ AuthGuard: isAuthenticated =', isAuth);
  
  if (isAuth) {
    return true;
  }

  console.warn('🛡️ AuthGuard: No autenticado - redirigiendo a login');
  router.navigate(['/login']);
  return false;
};
